import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';

import * as React from 'react';
import { useContext } from 'react';
import { SubscriptionDetailsStackRoutes, SubscriptionDetailsStackScreenProps } from '../subscriptionDetails/type';

import { RedeemConfirm } from './RedeemConfirm';
import { RedeemEdit } from './RedeemEdit';
import { RedeemMain } from './RedeemMain';
import { RedeemResult } from './RedeemResult';
import { RedeemStackParamList, RedeemStackRoutes } from './types';

const RedemptionStack = createNativeStackNavigator<RedeemStackParamList>();

export const RedeemNavigator: React.FC<SubscriptionDetailsStackScreenProps<SubscriptionDetailsStackRoutes.Redeem>> = ({ route }) => {
  const layout = useContext(LayoutContext);

  return (
    <RedemptionStack.Navigator
      initialRouteName={RedeemStackRoutes.Main}
      screenOptions={{ presentation: 'transparentModal', headerShown: false }}>
      <RedemptionStack.Screen name={RedeemStackRoutes.Main} component={RedeemMain} initialParams={{ ...route.params }} />
      <RedemptionStack.Screen
        name={RedeemStackRoutes.Edit}
        component={RedeemEdit}
        options={{ presentation: 'transparentModal' }}
        initialParams={{ ...route.params }}
      />
      <RedemptionStack.Screen
        name={RedeemStackRoutes.Confirm}
        component={RedeemConfirm}
        options={{ presentation: layout.isMobile ? 'transparentModal' : 'modal', headerShown: false }}
        initialParams={{ ...route.params }}
      />
      <RedemptionStack.Screen
        name={RedeemStackRoutes.Result}
        component={RedeemResult}
        options={{ headerShown: false, presentation: layout.isMobile ? 'transparentModal' : 'modal' }}
      />
    </RedemptionStack.Navigator>
  );
};
